// "use client";

// import { useState, useMemo } from "react";
// import Link from "next/link";
// import { useRouter } from "next/router";
// import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
// import { useLanguage } from "../../context/LanguageContext";

// export default function MobileDrillMenuEntry({
//   title,
//   items = [],
//   isService,
//   onNavigate,
// }) {
//   const router = useRouter();
//   const { locale } = useLanguage();
//   const rtl = locale === "ar";

//   const ForwardIcon = rtl ? IoIosArrowBack : IoIosArrowForward;
//   const BackIcon = rtl ? IoIosArrowForward : IoIosArrowBack;

//   const [stack, setStack] = useState([]);

//   const openRoot = () => setStack([{ title, items, baseParts: [] }]);
//   const closeAll = () => setStack([]);
//   const goBack = () => setStack((prev) => prev.slice(0, -1));

//   const currentIndex = stack.length - 1;
//   const current = stack[currentIndex];
//   const pages = useMemo(() => stack, [stack]);

//   const labelFor = (item) => {
//     if (isService) return item?.menuname || item?.title || "";
//     return item?.name || item?.title || "";
//   };

//   const hrefFor = (item, pageBaseParts = []) => {
//     if (!item) return "#";

//     if (isService) {
//       if (item?.fullSlug_en) return `/${item.fullSlug_en}`;
//       if (item?.fullSlug) return `/${item.fullSlug}`;
//       if (item?.slug) {
//         const parts = [...pageBaseParts, item.slug].filter(Boolean);
//         return `/${parts.join("/")}`;
//       }
//       return "#";
//     }

//     if (item?.slug) return `/industry/${item.slug}`;
//     return "#";
//   };

//   const getNextItems = (item) => {
//     if (!item) return null;

//     if (isService) {
//       if (Array.isArray(item?.services) && item.services.length > 0) {
//         return item.services;
//       }
//       if (Array.isArray(item?.children) && item.children.length > 0) {
//         return item.children;
//       }
//       if (Array.isArray(item?.grandchildren) && item.grandchildren.length > 0) {
//         return item.grandchildren;
//       }
//       return null;
//     }

//     if (Array.isArray(item?.children) && item.children.length > 0) {
//       return item.children;
//     }
//     if (Array.isArray(item?.grandchildren) && item.grandchildren.length > 0) {
//       return item.grandchildren;
//     }
//     return null;
//   };

//   const getNextBaseParts = (item, pageBaseParts = []) => {
//     if (!isService) return pageBaseParts;

//     if (item?.fullSlug_en) {
//       return item.fullSlug_en.split("/").filter(Boolean);
//     }

//     if (item?.fullSlug) {
//       return item.fullSlug.split("/").filter(Boolean);
//     }

//     if (item?.slug) {
//       return [...pageBaseParts, item.slug];
//     }

//     return pageBaseParts;
//   };

//   if (!current) {
//     return (
//       <button
//         onClick={openRoot}
//         className="w-full flex items-center justify-between py-3 px-0 text-left border-b border-white/10 text-[14px] text-white bg-black appearance-none border-0"
//         type="button"
//       >
//         <span className="font-semibold">{title}</span>
//         <ForwardIcon className="text-white" size={18} />
//       </button>
//     );
//   }

//   const showExploreAll = stack.length === 1;
//   const exploreHref = isService ? "/services" : "/industry";

//   const handleExplore = async () => {
//     closeAll();
//     onNavigate?.();
//     await router.push(exploreHref, exploreHref, { locale });
//   };

//   return (
//     <div className="fixed inset-0 z-[9999] bg-black text-white flex flex-col">
//       <div className="relative flex items-center h-12 border-b border-white/10 bg-black px-2 shrink-0">
//         <button
//           onClick={stack.length > 1 ? goBack : closeAll}
//           className="w-10 h-10 flex items-center justify-center text-white bg-black"
//           aria-label={stack.length > 1 ? "Back" : "Close menu"}
//           type="button"
//         >
//           <BackIcon size={18} className="text-white" />
//         </button>

//         <div className="absolute left-1/2 -translate-x-1/2 max-w-[62%] text-[14px] font-semibold truncate text-white text-center">
//           {current.title}
//         </div>

//         <button
//           onClick={closeAll}
//           className="ml-auto w-5 h-5 flex items-center justify-center text-white bg-black"
//           aria-label="Close"
//           type="button"
//         >
//           <span className="text-[17px] leading-none">×</span>
//         </button>
//       </div>

//       <div className="relative flex-1 overflow-hidden bg-black">
//         <div
//           className="h-full flex transition-transform duration-300 ease-in-out will-change-transform"
//           style={{
//             width: "100%",
//             transform: `translateX(${(rtl ? 1 : -1) * currentIndex * 100}%)`,
//           }}
//         >
//           {pages.map((page, pageIdx) => (
//             <div
//               key={`${page.title}-${pageIdx}`}
//               className="h-full shrink-0"
//               style={{ flex: "0 0 100%" }}
//             >
//               <div className="h-full overflow-y-auto bg-black">
//                 <div className="px-3 py-2">
//                   {page.items.map((item, idx) => {
//                     const label = labelFor(item);
//                     const nextItems = getNextItems(item);
//                     const nextBaseParts = getNextBaseParts(
//                       item,
//                       page.baseParts,
//                     );
//                     const href = hrefFor(item, page.baseParts);

//                     return (
//                       <div
//                         key={`${item?._id || item?.slug || idx}`}
//                         className="flex items-center justify-between py-2 border-b border-white/10"
//                       >
//                         <Link
//                           href={href}
//                           className={`flex-1 text-white no-underline text-[14px] leading-[1.2] ${
//                             rtl ? "pl-3" : "pr-3"
//                           }`}
//                           onClick={() => {
//                             closeAll();
//                             onNavigate?.();
//                           }}
//                         >
//                           {label}
//                         </Link>

//                         {nextItems?.length ? (
//                           <button
//                             onClick={() =>
//                               setStack((prev) => [
//                                 ...prev,
//                                 {
//                                   title: label,
//                                   items: nextItems,
//                                   baseParts: nextBaseParts,
//                                 },
//                               ])
//                             }
//                             className="shrink-0 w-9 h-9 flex items-center justify-center bg-black text-white"
//                             aria-label="Open"
//                             type="button"
//                           >
//                             <ForwardIcon size={18} className="text-white" />
//                           </button>
//                         ) : (
//                           <span className="w-9 h-9" />
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {showExploreAll && (
//         <div className="bg-black border-t border-white/10 px-3 py-3 shrink-0">
//           <button
//             onClick={handleExplore}
//             className="w-full rounded-full bg-[#e72c46] text-white py-3 text-[14px] font-semibold"
//             type="button"
//           >
//             Explore All
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

"use client";

import { useState, useMemo } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useLanguage } from "../../context/LanguageContext";

export default function MobileDrillMenuEntry({
  title,
  items = [],
  isService,
  isTools,
  onNavigate,
}) {
  const router = useRouter();
  const { locale } = useLanguage();
  const rtl = locale === "ar";

  const ForwardIcon = rtl ? IoIosArrowBack : IoIosArrowForward;
  const BackIcon = rtl ? IoIosArrowForward : IoIosArrowBack;

  const [stack, setStack] = useState([]);

  const openRoot = () => setStack([{ title, items, baseParts: [] }]);
  const closeAll = () => setStack([]);
  const goBack = () => setStack((prev) => prev.slice(0, -1));

  const currentIndex = stack.length - 1;
  const current = stack[currentIndex];
  const pages = useMemo(() => stack, [stack]);

  const labelFor = (item) => {
    if (isTools) return item?.label || item?.title || "";
    if (isService) return item?.menuname || item?.title || "";
    return item?.name || item?.title || "";
  };

  const hrefFor = (item, pageBaseParts = []) => {
    if (!item) return "#";

    if (isTools) return item?.path || item?.url || "#";

    if (isService) {
      if (item?.fullSlug_en) return `/${item.fullSlug_en}`;
      if (item?.fullSlug) return `/${item.fullSlug}`;
      if (item?.slug) {
        const parts = [...pageBaseParts, item.slug].filter(Boolean);
        return `/${parts.join("/")}`;
      }
      return "#";
    }

    if (item?.slug) return `/industry/${item.slug}`;
    return "#";
  };

  const getNextItems = (item) => {
    if (!item) return null;
    if (isTools) return null; // Tools items are always leaf nodes

    if (isService) {
      if (Array.isArray(item?.services) && item.services.length > 0)
        return item.services;
      if (Array.isArray(item?.children) && item.children.length > 0)
        return item.children;
      if (Array.isArray(item?.grandchildren) && item.grandchildren.length > 0)
        return item.grandchildren;
      return null;
    }

    if (Array.isArray(item?.children) && item.children.length > 0)
      return item.children;
    if (Array.isArray(item?.grandchildren) && item.grandchildren.length > 0)
      return item.grandchildren;
    return null;
  };

  const getNextBaseParts = (item, pageBaseParts = []) => {
    if (!isService) return pageBaseParts;

    if (item?.fullSlug_en) return item.fullSlug_en.split("/").filter(Boolean);
    if (item?.fullSlug) return item.fullSlug.split("/").filter(Boolean);
    if (item?.slug) return [...pageBaseParts, item.slug];
    return pageBaseParts;
  };

  if (!current) {
    return (
      <button
        onClick={openRoot}
        className="w-full flex items-center justify-between py-3 px-0 text-left border-b border-white/10 text-[14px] text-white bg-black appearance-none border-0"
        type="button"
      >
        <span className="font-semibold">{title}</span>
        <ForwardIcon className="text-white" size={18} />
      </button>
    );
  }

  // "Explore All" only makes sense for Services and Industries, not Tools
  const showExploreAll = !isTools && stack.length === 1;
  const exploreHref = isService ? "/services" : "/industry";

  const handleExplore = async () => {
    closeAll();
    onNavigate?.();
    await router.push(exploreHref, exploreHref, { locale });
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black text-white flex flex-col">
      <div className="relative flex items-center h-12 border-b border-white/10 bg-black px-2 shrink-0">
        <button
          onClick={stack.length > 1 ? goBack : closeAll}
          className="w-10 h-10 flex items-center justify-center text-white bg-black"
          aria-label={stack.length > 1 ? "Back" : "Close menu"}
          type="button"
        >
          <BackIcon size={18} className="text-white" />
        </button>

        <div className="absolute left-1/2 -translate-x-1/2 max-w-[62%] text-[14px] font-semibold truncate text-white text-center">
          {current.title}
        </div>

        <button
          onClick={closeAll}
          className="ml-auto w-5 h-5 flex items-center justify-center text-white bg-black"
          aria-label="Close"
          type="button"
        >
          <span className="text-[17px] leading-none">×</span>
        </button>
      </div>

      <div className="relative flex-1 overflow-hidden bg-black">
        <div
          className="h-full flex transition-transform duration-300 ease-in-out will-change-transform"
          style={{
            width: "100%",
            transform: `translateX(${(rtl ? 1 : -1) * currentIndex * 100}%)`,
          }}
        >
          {pages.map((page, pageIdx) => (
            <div
              key={`${page.title}-${pageIdx}`}
              className="h-full shrink-0"
              style={{ flex: "0 0 100%" }}
            >
              <div className="h-full overflow-y-auto bg-black">
                <div className="px-3 py-2">
                  {page.items.map((item, idx) => {
                    const label = labelFor(item);
                    const nextItems = getNextItems(item);
                    const nextBaseParts = getNextBaseParts(
                      item,
                      page.baseParts,
                    );
                    const href = hrefFor(item, page.baseParts);

                    return (
                      <div
                        key={`${item?._id || item?.slug || item?.path || idx}`}
                        className="flex items-center justify-between py-2 border-b border-white/10"
                      >
                        <Link
                          href={href}
                          className={`flex-1 text-white no-underline text-[14px] leading-[1.2] ${
                            rtl ? "pl-3" : "pr-3"
                          }`}
                          onClick={() => {
                            closeAll();
                            onNavigate?.();
                          }}
                        >
                          {label} {isTools && "(Free)"}
                        </Link>

                        {nextItems?.length ? (
                          <button
                            onClick={() =>
                              setStack((prev) => [
                                ...prev,
                                {
                                  title: label,
                                  items: nextItems,
                                  baseParts: nextBaseParts,
                                },
                              ])
                            }
                            className="shrink-0 w-9 h-9 flex items-center justify-center bg-black text-white"
                            aria-label="Open"
                            type="button"
                          >
                            <ForwardIcon size={18} className="text-white" />
                          </button>
                        ) : (
                          <span className="w-9 h-9" />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showExploreAll && (
        <div className="bg-black border-t border-white/10 px-3 py-3 shrink-0">
          <button
            onClick={handleExplore}
            className="w-full rounded-full bg-[#e72c46] text-white py-3 text-[14px] font-semibold"
            type="button"
          >
            Explore All
          </button>
        </div>
      )}
    </div>
  );
}
